import React, { useContext } from "react";
import { GlobalDataContext } from "../../context/context";
import { ButtonContent } from "../global/boton/ButtonContent";
function HeroVideo({urlVideo}) {
    const { rpdata } = useContext(GlobalDataContext);
    return (
        <div>
            <div className="w-full relative content_video flex justify-center ">
                <video

                    playsInline
                    autoPlay
                    muted
                    loop
                    className="w-full md:h-full object-cover"
                >
                    <source
                        src={urlVideo}
                        type="video/mp4"
                    />
                </video>
                <div className="flex md:flex-row flex-col md:w-4/5 mx-auto absolute bottom-[30px] md:bottom-[100px] lg:bottom-[30px] md:text-start text-center text-white">
                    <div className="w-full p-4">
                        <h1 className="text-[30px] md:text-[3em] lg:text-[3.8em] text-white md:text-start text-center">{rpdata?.dbSlogan?.[0].slogan}</h1>
                        <p className="text-white md:text-start text-center">{rpdata?.dbValues?.[0].description.substring(0, 287)}</p>
                        <ButtonContent btnStyle="three" />
                    </div>
                    <div className="md:w-1/2 w-full flex justify-center items-center">
            <img src="https://firebasestorage.googleapis.com/v0/b/imagenes-fc412.appspot.com/o/Años%20de%20experiencia%2F16%20Años.png?alt=media&token=6065fdd9-ffa7-4d8c-9826-d08764f65a69"
              alt="yearsnone" 
              className="md:w-[300px] w-[180px] md:-mt-10 mt-5"/>
          </div>
                </div>
            </div>
        </div>
    );
}
export default HeroVideo;